import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { History, ShieldCheck, User, Building2, FileText } from "lucide-react";

const ACTION_META = {
  "auth.login": { color: "#3FA84D", icon: ShieldCheck, label: "Login" },
  "auth.login_failed": { color: "#D63384", icon: ShieldCheck, label: "Login fallido" },
  "auth.logout": { color: "#6E7591", icon: ShieldCheck, label: "Logout" },
  "user.create": { color: "#2C49A0", icon: User, label: "Usuario creado" },
  "user.update": { color: "#F5B82E", icon: User, label: "Usuario actualizado" },
  "user.delete": { color: "#D63384", icon: User, label: "Usuario eliminado" },
  "franchise.create": { color: "#3FA84D", icon: Building2, label: "Franquicia creada" },
  "franchise.update": { color: "#F5B82E", icon: Building2, label: "Franquicia actualizada" },
  "evaluation.conduct": { color: "#2C49A0", icon: FileText, label: "Diagnóstico 1:1" },
};

export default function AdminAuditoria() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/audit-logs", { params: { limit: 200 } }).then((r) => setLogs(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6" data-testid="admin-audit-page">
      <div>
        <p className="text-xs tracking-[0.18em] uppercase font-bold text-[#2C49A0]">KR4 · ≥95% eventos críticos</p>
        <h1 className="font-display text-3xl md:text-4xl font-extrabold text-[#1F2547]">Bitácora de auditoría</h1>
        <p className="text-sm text-[#6E7591] mt-1">Cada acción crítica queda registrada con actor, entidad, franquicia y fecha.</p>
      </div>

      <div className="jasq-card overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="border-b-2 border-[#E1E5F0] bg-[#F7F8FA]">
              <th className="text-left text-[11px] tracking-wider uppercase font-extrabold text-[#6E7591] px-5 py-3">Acción</th>
              <th className="text-left text-[11px] tracking-wider uppercase font-extrabold text-[#6E7591] px-5 py-3">Actor</th>
              <th className="text-left text-[11px] tracking-wider uppercase font-extrabold text-[#6E7591] px-5 py-3">Entidad</th>
              <th className="text-left text-[11px] tracking-wider uppercase font-extrabold text-[#6E7591] px-5 py-3">Franquicia</th>
              <th className="text-left text-[11px] tracking-wider uppercase font-extrabold text-[#6E7591] px-5 py-3">Fecha</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={5} className="text-center text-sm text-[#6E7591] py-8">Cargando…</td></tr>}
            {!loading && logs.length === 0 && <tr><td colSpan={5} className="text-center text-sm text-[#6E7591] py-8">Sin eventos.</td></tr>}
            {logs.map((l) => {
              const meta = ACTION_META[l.action] || { color: "#6E7591", icon: History, label: l.action };
              const Icon = meta.icon;
              return (
                <tr key={l.id} className="border-b border-[#E1E5F0] last:border-0 hover:bg-[#FAFBFE]" data-testid={`audit-row-${l.id}`}>
                  <td className="px-5 py-3">
                    <div className="flex items-center gap-2.5">
                      <span className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: `${meta.color}1A`, color: meta.color }}>
                        <Icon size={15} />
                      </span>
                      <div>
                        <p className="font-bold text-sm text-[#1F2547]">{meta.label}</p>
                        <p className="text-[11px] text-[#6E7591]">{l.action}</p>
                      </div>
                    </div>
                  </td>
                  <td className="px-5 py-3 text-sm text-[#4C5478]">{l.actor_email || "—"}</td>
                  <td className="px-5 py-3 text-sm text-[#4C5478]">{l.entity}{l.entity_id ? ` · ${l.entity_id}` : ""}</td>
                  <td className="px-5 py-3 text-sm text-[#6E7591]">{l.franchise_id || "global"}</td>
                  <td className="px-5 py-3 text-xs text-[#6E7591] whitespace-nowrap">{new Date(l.timestamp).toLocaleString("es-ES")}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
